// ------------------ React Components ------------------------
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { CiImageOn, CiSearch } from "react-icons/ci";
import { LiaSpinnerSolid } from "react-icons/lia";
import { MdDeleteOutline } from "react-icons/md";
import { FaRegSave, FaClipboardList, FaSpinner } from 'react-icons/fa';
import blueKbcLogo from '../../../assets/images/branding/blue-kbc-logo.png';
import ItemAddedToaster from '../../toasterscomponents/checklistToasters/ItemAddedToaster';
import FilledInChecklistToaster from '../../toasterscomponents/FilledInChecklistToaster';
import CreatedSuccesFullyToaster from '../../toasterscomponents/shepacktoasters/CreatedSuccesFullyToaster';
import QARejectToaster from './QARejectToaster';
import { TbMessage2Cancel } from 'react-icons/tb';

const ToasterQaViewSubmissions = ({ 
  isOpen, 
  onClose, 
  selectedShePackName,
  shePackDocuments,
  isLoading,
  questionsPerDocument,

  selectedCompany,
  selectedDepartment,// Add this prop
  selectedCompanyName,
  selectedDepartmentName,

  selectedUser,
  selectedUserFullName
  

}) => {
  const navigate = useNavigate();
  const [isExpanded, setIsExpanded] = useState(false);
  const [showToaster, setShowToaster] = useState({});

  const [showSuccess, setShowSuccess] = useState(false);
  const [showRejectSuccess, setShowRejectSuccess] = useState(false);

  const [totalUserScore, setTotalUserScore] = useState(0);
  const [totalUserPercentage, setTotalUserPercentage] = useState(0);
  const [shePackScore, setShePackScore] = useState(0)


  const [submitStatus, setSubmitStatus] = useState(null);
  const [answers, setAnswers] = useState({});
  const [previewPhoto, setPreviewPhoto] = useState(null);
  const [isPreviewExpanded, setIsPreviewExpanded] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [questionErrors, setQuestionErrors] = useState({});
  const [questionCategoryErrors, setQuestionCategoryErrors] = useState({});
  const [expiryDateInput, setExpiryDateInput] = useState({});
  const [expandedDocuments, setExpandedDocuments] = useState({});

  const [comments, setComments] = useState({});
  const [qaComments, setQaComments] = useState({})

  const [questionScores, setQuestionScores] = useState({});
  const [files, setFiles] = useState({});
  const [removedPreviousFiles, setRemovedPreviousFiles] = useState({});
  const [expandedImageIndex, setExpandedImageIndex] = useState(null);
    const [previewPhotos, setPreviewPhotos] = useState({});

  // Add this state to track the current document ID
  const [currentDocumentId, setCurrentDocumentId] = useState(null);
  const [showQARejectToaster, setShowQARejectToaster] = useState(false)

  const [fullScreenImage, setFullScreenImage] = useState(null);

  const [qaCommentLoading, setQaCommentLoading] = useState({});

  const user = JSON.parse(sessionStorage.getItem('user'));

  //
    // Add this to the useEffect that calculates the scores
  useEffect(() => {
    if (shePackDocuments && shePackDocuments.length > 0) {
      let userScoreSum = 0;
      let documentScoreSum = 0;
      
      shePackDocuments.forEach(doc => {
        // Add user score if it exists (convert to number to ensure proper addition)
        userScoreSum += doc.user_score ? Number(doc.user_score) : 0;
        
        // Use effective_document_score if available, otherwise use shepack_document_score
        const docScore = doc.effective_document_score ? Number(doc.effective_document_score) : 
                        (doc.shepack_document_score ? Number(doc.shepack_document_score) : 0);
        documentScoreSum += docScore;
      });
      
      setTotalUserScore(userScoreSum);
      setShePackScore(documentScoreSum); // Add this line to set the total shePackScore
      
      // Calculate percentage only if documentScoreSum is not zero to avoid division by zero
      if (documentScoreSum > 0) {
        const percentage = (userScoreSum / documentScoreSum) * 100;
        setTotalUserPercentage(percentage.toFixed(2)); // Round to 2 decimal places
      } else {
        setTotalUserPercentage(0);
      }
    }
  }, [shePackDocuments]);

  useEffect(() => {
    // Initialize previous responses when questions are loaded
    if (questionsPerDocument) {
      Object.entries(questionsPerDocument).forEach(([documentId, categories]) => {
        Object.values(categories).forEach(questions => {
          questions.forEach(question => {
            // Handle previous comments
            if (question.previous_comment) {
              setComments(prev => ({
                ...prev,
                [question.question_id]: question.previous_comment
              }));
            }

            // Initialize scores with "Not Selected" if no previous score exists
            if (question.previous_user_question_score === undefined) {
              setQuestionScores(prev => ({
                ...prev,
                [question.question_id]: "Not Selected"
              }));
            } else {
              setQuestionScores(prev => ({
                ...prev,
                [question.question_id]: question.previous_user_question_score
              }));
            }
          });
        });
      });
    }

  }, [questionsPerDocument]);

  
  useEffect(() => {
    const timers = Object.keys(showToaster).map(key => showToaster[key] && setTimeout(() => setShowToaster(prev => ({ ...prev, [key]: false })), 3000));
    return () => timers.forEach(timer => clearTimeout(timer));
  }, [showToaster]);

  const toggleDocument = (documentId) => {
    setExpandedDocuments(prev => ({ ...prev, [documentId]: !prev[documentId] }));
  };

  const closeFullScreenImage = () => {
    setFullScreenImage(null);
  };

  const handleRemovePreviousFile = (questionId) => {
    setRemovedPreviousFiles(prev => ({
      ...prev,
      [questionId]: true
    }));
    
    // Also clear any new files that might have been uploaded
    handleRemoveFile(questionId);
  };

  const handleAnswerChange = (questionId, answer, questionType) => {
    setAnswers(prev => {
      if (questionType === 'Multiple Select') {
        const currentAnswers = Array.isArray(prev[questionId]) ? prev[questionId] : [];
        return { ...prev, [questionId]: currentAnswers.includes(answer) ? currentAnswers.filter(item => item !== answer) : [...currentAnswers, answer] };
      } else {
        return { ...prev, [questionId]: answer };
      }
    });
  };

  const handleFileChange = (questionId, event) => {
    const file = event.target.files[0];
    if (file && (file.type === 'image/png' || file.type === 'image/jpeg' ) && file.size <= 10 * 1024 * 1024) {
      // Mark any previous file as removed
      setRemovedPreviousFiles(prev => ({
        ...prev,
        [questionId]: true
      }));
  
      // Update both answers and files state
      handleAnswerChange(questionId, file);
      setFiles(prev => ({ ...prev, [questionId]: file }));
  
      // Create a URL for the file and store it in previewPhotos with the questionId as key
      if (file.type.startsWith('image/')) {
        const objectUrl = URL.createObjectURL(file);
        setPreviewPhotos(prev => ({ ...prev, [questionId]: objectUrl }));
        setPreviewPhoto(objectUrl); // Keep this for backwards compatibility
      }
    } else {
      setErrorMessage('Only PNG and JPEG files less than 10MB are allowed.');
    }
  };

  const handleRemoveFile = (questionId) => {
    handleAnswerChange(questionId, '');
    setPreviewPhoto(null);
    document.querySelectorAll('input[type="file"]').forEach(input => input.value = '');
  };

  const handleQaCommentChange = (questionId, qaComment) => {
  setQaComments(prev => ({
    ...prev,
    [questionId]: qaComment
  }));
};


  const handleCommentChange = (questionId, comment) => {
    setComments(prev => ({
      ...prev,
      [questionId]: comment
    }));
  };


 

  const handleScoreChange = (questionId, score) => {
    setQuestionScores(prev => ({
      ...prev,
      [questionId]: score
    }));
  };

  const generateScoreOptions = (maxScore) => {
    const options = [<option key="not-selected" value="Not Selected">Not Selected</option>];
    for (let i = 0; i <= maxScore; i += 5) {
      options.push(<option key={i} value={i.toString()}>{i}</option>);
    }
    options.push(<option key="not-applicable" value="Not Applicable">Not Applicable</option>);
    return options;
  };

  
  // Update the handleQaCommentReject function
const handleQaCommentReject = async (questionId) => {
  const qaComment = qaComments[questionId];
  
  if (!qaComment || qaComment.trim() === '') {
    setErrorMessage('Please enter a QA comment before saving.');
    return;
  }

  // Set loading state for this specific question
  setQaCommentLoading(prev => ({ ...prev, [questionId]: true }));

  try {
    await axios.post(`/api/quality-assurance/reject-consultant-submission/question/qa-comment/${selectedUser}`, {
      questionId,
      qaComment
    });

    setShowToaster(prev => ({ ...prev, fileSaved: true }));
    setErrorMessage('');

  } catch (error) {
    console.log(error);
    const errorMsg = error.response?.data?.message 
      ? `Server error: ${error.response.data.message}`
      : error.request 
        ? 'No response from server. Please check your connection.'
        : `Error: ${error.message}`;
    setErrorMessage(errorMsg);
  } finally {
    // Clear loading state for this specific question
    setQaCommentLoading(prev => ({ ...prev, [questionId]: false }));
  }
};

  

  
  // Modified processRejection function to include QA comments
const handleReject = async (reason, documentId) => {
  setSubmitStatus('loading');
  try {
    const currentDocument = shePackDocuments.find(doc => doc.shepack_document_id === documentId);
    if (!currentDocument) throw new Error('Document not found');

    const documentQuestions = questionsPerDocument[documentId];
    if (!documentQuestions) throw new Error('No questions found for this document');

    const formData = new FormData();
    formData.append('shePackDocumentId', documentId);
    formData.append('shePackDocumentName', currentDocument.shepack_document_name);
    formData.append('userId', selectedUser);
    formData.append('userName', user.userName);
    formData.append('userSurname', user.userSurname);
    formData.append('userType', user.userType);
    formData.append('companyId', selectedCompany);
    formData.append('departmentId', selectedDepartment);
    formData.append('rejectionReason', reason);

    // Add QA comments for all questions in the document
    let questionIndex = 0;
    Object.entries(documentQuestions).forEach(([category, questions]) => {
      questions.forEach((question) => {
        const questionId = question.question_id;
        
        formData.append(`questions[${questionIndex}].questionId`, questionId);
        formData.append(`questions[${questionIndex}].questionName`, question.question_name);
        formData.append(`questions[${questionIndex}].category`, category);
        
        // Include QA comment if it exists
        if (qaComments[questionId]) {
          formData.append(`questions[${questionIndex}].qa_comment`, qaComments[questionId]);
        }
        
        questionIndex++;
      });
    });

    // Also append the JSON string of QA comments
    const qaCommentsData = [];
    Object.entries(documentQuestions).forEach(([category, questions]) => {
      questions.forEach(question => {
        const questionId = question.question_id;
        if (qaComments[questionId]) {
          qaCommentsData.push({
            questionId: questionId,
            questionName: question.question_name,
            category: category,
            qa_comment: qaComments[questionId]
          });
        }
      });
    });
    
    if (qaCommentsData.length > 0) {
      formData.append('qaComments', JSON.stringify(qaCommentsData));
    }

    // Make API call to reject the submission
    await axios.post(
      '/api/quality-assurance/view-template-submissions/reject-submission',
      formData,
      {
        headers: { 'Content-Type': 'multipart/form-data' }
      }
    );

    setSubmitStatus('success');
    setShowSuccess(true);
    setTimeout(() => {
      navigate('/she-pack/she-pack-management');
    }, 2000);
      
  } catch (error) {
    setSubmitStatus('idle');
    const errorMsg = error.response?.data?.message 
      ? `Server error: ${error.response.data.message}`
      : error.request 
        ? 'No response from server. Please check your connection.'
        : `Error: ${error.message}`;
    setErrorMessage(errorMsg);
  }
};

  const handleSubmit = async (documentId) => {
    setErrorMessage('');
    setSubmitStatus('loading');
  
    const currentDocument = shePackDocuments.find(doc => doc.shepack_document_id === documentId);
    if (!currentDocument) {
      setErrorMessage('Document not found');
      setSubmitStatus('idle');
      return;
    }
  
    const documentQuestions = questionsPerDocument[documentId];
    if (!documentQuestions) {
      setErrorMessage('No questions found for this document');
      setSubmitStatus('idle');
      return;
    }
  
    // Validate all questions have valid scores
    const invalidScores = [];
    Object.entries(documentQuestions).forEach(([category, questions]) => {
      questions.forEach(question => {
        const score = questionScores[question.question_id];
        if (!score || score === 'Not Selected') {
          invalidScores.push(question.question_name);
        }
      });
    });
  
    if (invalidScores.length > 0) {
      setSubmitStatus('error');
      setErrorMessage(`Please select a score or mark as Not Applicable for the following questions: ${invalidScores.join(', ')}`);
      return; // Prevent submission if any question has Not Selected
    }
  
    try {
      // Calculate updated document score excluding Not Applicable questions
      let updatedDocumentScore = 0;
      let userTotalScore = 0;
  
      if (!currentDocument) throw new Error('Document not found');
      if (!documentQuestions) throw new Error('No questions found for this document');
      
      const unansweredMandatoryQuestions = [];
  
      Object.entries(documentQuestions).forEach(([category, questions]) => {
        questions.forEach(q => {
          const questionScore = questionScores[q.question_id];
          // Only include in updated document score if not marked as Not Applicable
          if (questionScore !== 'Not Applicable') {
            updatedDocumentScore += parseInt(q.question_score);
          }
          // Calculate user's total score
          if (questionScore !== 'Not Applicable' && questionScore !== 'Not Selected') {
            userTotalScore += parseInt(questionScore);
          }
        });
      });
  
      if (unansweredMandatoryQuestions.length > 0) {
        setSubmitStatus('error');
        setErrorMessage(`Please answer all mandatory questions: ${unansweredMandatoryQuestions.join(', ')}`);
        return;
      }
      
      const formData = new FormData();
      formData.append('shePackDocumentId', documentId);
      formData.append('shePackDocumentName', currentDocument.shepack_document_name);
      formData.append('userId', selectedUser);
      formData.append('userName', user.userName);
      formData.append('userSurname', user.userSurname);
      formData.append('userType', user.userType);
      formData.append('companyId', selectedCompany);
      formData.append('departmentId', selectedDepartment);
  
      // Use calculated values instead of stored values
      formData.append('userTotalScore', userTotalScore.toString());
      formData.append('shepackDocumentscore', currentDocument.shepack_document_score || 0);
      formData.append('updatedShePackDocumentScore', updatedDocumentScore.toString());
      formData.append('totalUserScorePercentage', ((userTotalScore / updatedDocumentScore) * 100).toFixed(2));
  
      // Process each question individually and append to formData
      let questionIndex = 0;
      
      // Track which files will be included in the request
      const includedFiles = new Set();
      
      Object.entries(documentQuestions).forEach(([category, questions]) => {
        questions.forEach((question) => {
          const questionId = question.question_id;
          
          formData.append(`questions[${questionIndex}].questionId`, questionId);
          formData.append(`questions[${questionIndex}].questionName`, question.question_name);
          formData.append(`questions[${questionIndex}].questionType`, question.question_type);
          formData.append(`questions[${questionIndex}].category`, category);
          formData.append(`questions[${questionIndex}].questionScore`, questionScores[questionId] || '');
          
          // Handle different question types for answers
          const answer = answers[questionId];
          if (question.question_type === 'Multiple Select') {
            formData.append(`questions[${questionIndex}].answer`, Array.isArray(answer) ? answer.join(', ') : answer || '');
          } else {
            // For regular answers, preserve existing answer if no new input
            formData.append(`questions[${questionIndex}].answer`, answer || '');
          }
          
          // For file questions - only include the file if a new one was selected
          // Don't override existing file answer if no new file is selected
          if (question.is_File_required === 'Yes') {
            if (files[questionId]) {
              // If we have a new file, include it in the form data
              formData.append(`files[${questionId}]`, files[questionId]);
              formData.append(`questions[${questionIndex}].answer`, files[questionId].name);
              // Track that we're including this file
              includedFiles.add(questionId);
            } else {
              // If no new file is selected, DON'T set answer to empty string
              // We'll let the server use the existing file from the database
              // Only need to explicitly set answer to empty if there's no existing file
              
              // Important: Don't override the answer field if no new file is selected
              // The backend will keep the existing file if no new file is provided
            }
          }
          
          // Add optional fields
          if (comments[questionId]) {
            formData.append(`questions[${questionIndex}].comment`, comments[questionId]);
          }

          if (qaComments[questionId]) {
            formData.append(`questions[${questionIndex}].qa_comment`, qaComments[questionId]);
          }
                    
          if (expiryDateInput[questionId]) {
            formData.append(`questions[${questionIndex}].expiry_date`, expiryDateInput[questionId]);
          }
          
          // Add a special flag for file questions that don't have a new file
          // This helps the backend know whether to keep existing files or not
          if (question.is_File_required === 'Yes' && !includedFiles.has(questionId)) {
            formData.append(`questions[${questionIndex}].keepExistingFile`, 'true');
          }
          
          questionIndex++;
        });
      });
  
      // Also append the JSON string of all answers for backward compatibility
      // but respect the file preservation logic
      const allAnswers = [];
      Object.entries(documentQuestions).forEach(([category, questions]) => {
        questions.forEach(question => {
          const questionId = question.question_id;
          const answer = answers[questionId];
          const answerData = {
            questionId: questionId,
            questionName: question.question_name,
            questionType: question.question_type,
            category: category,
            answer: '',
            questionScore: questionScores[questionId],
            comment: comments[questionId] || null,
            
            expiry_date: expiryDateInput[questionId] || '',
            companyId: selectedCompany,
            departmentId: selectedDepartment,
          };
  
          if (question.question_type === 'Multiple Select') {
            answerData.answer = Array.isArray(answer) ? answer.join(', ') : answer || '';
          } else {
            answerData.answer = answer || '';
          }
  
          // Update answer with file name only if a new file was selected
          if (question.is_File_required === 'Yes' && files[questionId]) {
            answerData.answer = files[questionId].name;
          } else if (question.is_File_required === 'Yes') {
            // If no new file is selected, indicate that we should keep existing file
            answerData.keepExistingFile = true;
          }
  
          allAnswers.push(answerData);
        });
      });
      formData.append('answers', JSON.stringify(allAnswers));
  
      console.log('Submitting form data:', {
        documentId,
        documentName: currentDocument.shepack_document_name,
        answersCount: allAnswers.length,
        updatedDocumentScore
      });
  
      await axios.post('/api/quality-assurance/consultant/submit-approved-template', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      
      setSubmitStatus('success');
      setShowSuccess(true);
      setTimeout(() => {
        setShowSuccess(false);
        navigate('/she-pack/she-pack-management');
      }, 2000);
    } catch (error) {
      console.error('Submit error:', error);
      setSubmitStatus('idle');
      const errorMsg = error.response?.data?.message 
        ? `Server error: ${error.response.data.message}`
        : error.request 
          ? 'No response from server. Please check your connection.'
          : `Error: ${error.message}`;
      setErrorMessage(errorMsg);
    }
  };

  //
  const bufferToBase64 = (buffer) => {
      if (buffer && buffer.type === 'Buffer' && Array.isArray(buffer.data)) {
        const binaryString = buffer.data.map(byte => String.fromCharCode(byte)).join('');
        return btoa(binaryString);
      }
      return null;
    };
  
    // This function to render previous file response
    const renderPreviousFileResponse = (question, index) => {
      if (removedPreviousFiles[question.question_id] || files[question.question_id]) {
        return null;
      }
      
      const fileResponse = question.previous_file_response;
      const base64String = bufferToBase64(fileResponse);
      if (!base64String) {
        return <p>Invalid image data</p>;
      }
    
      const base64ToBinary = atob(base64String);
      const mimeType = 'image/png'; // Assuming the mimeType is 'image/png'
      const dataUrl = `data:${mimeType};base64,${base64ToBinary}`;
    
      return (
        <div>
          
    
          <div className='checklist-question-toaster-image-delete-button-container'>
            <CiImageOn 
              className='checklist-question-toaster-image-icon' 
              onClick={() => setFullScreenImage(dataUrl)} 
            />
            
            <button 
              type='button' 
              className='delete-image-button' 
              onClick={() => handleRemovePreviousFile(question.question_id)}
            > 
              <MdDeleteOutline /> 
            </button>
          </div>
          {expandedImageIndex === index && (
            <div className="expanded-image-overlay" onClick={() => setExpandedImageIndex(null)}>
              <p>{question.previous_response}</p>
              <img
                className='view-checklist-view-image'
                src={dataUrl}
                alt='view'
                style={{ maxWidth: '200px', maxHeight: '200px' }} 
              />
            </div>
          )}
        </div>
      );
    };

  const renderQuestionOptions = (question) => {
    const options = ['option_1', 'option_2', 'option_3', 'option_4', 'option_5', 'option_6', 'option_7', 'option_8', 'option_9', 'option_10', 'option_11', 'option_12', 'option_13', 'option_14', 'option_15'];
    switch (question.question_type) {
      
     
      case 'File':
      case 'Photo':
        return (
          <div className='file-upload-container'>
            <p className='secondary-color-paragraph'>Please upload a {question.question_type}. File should not exceed 10MB</p>
            <input
              className='file-upload-input'
              type="file"
              accept={question.question_type === 'File' ? ".png,.jpg,.jpeg,.pdf" : "image/png, image/jpeg"}
              onChange={(e) => handleFileChange(question.question_id, e)}
            />
            {answers[question.question_id] && (
              <div>
                {answers[question.question_id].type.startsWith('image/') && (
                  <div className='checklist-question-toaster-image-delete-button-container'>
                    <CiImageOn className='checklist-question-toaster-image-icon' onClick={() => setIsPreviewExpanded(!isPreviewExpanded)} />
                    <button type='button' className='delete-image-button' onClick={() => handleRemoveFile(question.question_id)}> <MdDeleteOutline /> </button>
                  </div>
                )}
                {isPreviewExpanded && previewPhoto && (
                  <img onClick={() => setIsPreviewExpanded(false)} src={previewPhoto} alt="Preview" style={{ maxWidth: '200px', maxHeight: '200px' }} />
                )}
              </div>
            )}
          </div>
        );
      case 'Short Text':
        return (
          <div className='file-upload-container'>
            <input
              className="create-questions-form-name-input"
              type="text"
              value={answers[question.question_id] || ''}
              onChange={(e) => handleAnswerChange(question.question_id, e.target.value)}
              placeholder="Please enter your response"
            />
          </div>
        );
      case 'Time':
        return (
          <div className='file-upload-container'>
            <input
              type="time"
              value={answers[question.question_id] || ''}
              onChange={(e) => handleAnswerChange(question.question_id, e.target.value)}
            />
          </div>
        );
      case 'Date':
        return (
          <div className='file-upload-container'>
            <input
              type="date"
              value={answers[question.question_id] || ''}
              onChange={(e) => handleAnswerChange(question.question_id, e.target.value)}
              max={new Date().toISOString().split('T')[0]}
              className='checklist-question-toaster-date'
            />
          </div>
        );
      case 'Drop Down':
        return (
          <div className='file-upload-container'>
            <select
              value={answers[question.question_id] || ''}
              onChange={(e) => handleAnswerChange(question.question_id, e.target.value)}
            >
              <option value="">Select an option</option>
              {options.map((option, optionIndex) => (
                question[option] && (
                  <option key={optionIndex} value={question[option]}>
                    {question[option]}
                  </option>
                )
              ))}
            </select>
          </div>
        );
      default:
        return null;
    }
  };

  if (!isOpen) return null;

  return (

    <div className="checklist-question-user-fill-in-checklist-main-container">
        
        <div className="template-question-fill-in-checklist-container">
        <div className="template-fill-in-elements-container">
          <div className="consultant-fill-in-template-main-container">
            <div className='user-fill-in-back-button-container'>
              <img src={blueKbcLogo} alt="white-kbc-logo" className="add-quesiton-side-menu-logo" />
              <button type="button" onClick={onClose} className="user-fill-in-back-button"> Back</button>
            </div>
          </div>
          
          <div className="consultant-Template-fill-in-header-main-container">
            <div className="Template-fill-in-header-text-and-search-main-container">

              <div className="Template-fill-in-header-text-main-container">
                <h2> Legal Compliance - <span className="secondary-color-paragraph">(QA) Review Consultants Submission</span></h2>
                <p>You are doing QA for company <span className='secondary-color-text'>{selectedCompanyName}</span> for the following site <span className='secondary-color-text'>{selectedDepartmentName}</span></p>
                <p>Submitted By: {selectedUserFullName}</p>
                
              </div>

              <div>

                <div className='consultant-fill-in-she-file-score-display-main-main-container'>
                    <h4>SHE File :<span className='secondary-color-paragraph'> {selectedShePackName}</span></h4>

                    <div className='consultant-fill-in-she-file-score-display-main-container'>

                      <div>
                        <p><span className='secondary-color-paragraph'>Score</span></p>
                      </div>
                      <div>
                        {totalUserScore} / {shePackScore}
                      </div>
                    </div>

                    <div>
                      <p><span className='secondary-color-paragraph'>Percentage : {totalUserPercentage || 0} %</span></p>
                    </div>
                  </div>
                  
              </div>

            </div>
            {isLoading ? (
              <div className="loading-spinner-container">
                <LiaSpinnerSolid className="lia-spin-solid-icon" />
              </div>
            ) : (
              <div className='compliance-tracker-consultant-fill-in-table-main-container'>
                <div className="compliance-tracker-consultant-fill-in-table-container">
                  <table className='compliance-tracker-consultant-fill-in-table'>
                    <colgroup>

                      <col style={{width: "50px"}}/>{/* view */}
                      <col style={{width: "350px"}}/>{/* template name */}
                      <col style={{width: "150px"}}/>{/* Template score */}
                      <col style={{width: "100px"}}/>{/* Template % */}
                      <col style={{width: "150px"}}/>{/* Submission Status */}
                      <col style={{width: "150px"}}/>{/* QA Status */}
                      <col style={{width: "300px"}}/>{/* QA Status Comment */}
                      
                    </colgroup>

                    <thead>

                      <th>View Questions</th>
                      <th>Template Name</th>
                      <th>Template Score</th>
                      <th>Template %</th>
                      <th>Status</th>
                      <th>QA Status</th>
                      <th>QA Status Comment</th>

                    </thead>

                    <tbody>
                      {shePackDocuments.length === 0 ? (
                      <tr >
                        <td colSpan="7">
                          <i >There are no documents submitted for this SHE Pack that are currently ready for QA review.</i>
                        </td>
                      </tr>
                    ) : (
                      shePackDocuments.map((document, index) => (
                        <>
                        
                          <tr key={index}>

                            <td >
                              <FaClipboardList 
                                className='view-checklist-submition-icon' 
                                onClick={() => toggleDocument(document.shepack_document_id)}
                                
                              />
                            </td>


                            <td>{document.shepack_document_name}</td>
                            <td>  {document.user_score} / {document.effective_document_score || document.shepack_document_score}</td>
                            <td>{document.user_percentage } %</td>
                            <td>{document.submission_status || 'No submission'}</td>
                            <td>{document.qa_status }</td>
                            <td>{document.qa_status_comment }</td>
                          </tr>
                          {expandedDocuments[document.shepack_document_id] && (

                            <tr>
                              <td colSpan="7">

                                <div className='template-questions-fill-in-main-container'>
                              {questionsPerDocument[document.shepack_document_id] && 
                                Object.entries(questionsPerDocument[document.shepack_document_id]).map(([category, categoryQuestions]) => (
                                  <div key={category}>  
                                    <div className='template-questions-fill-in-container'>
                                      <div className='checklist-question-toaster-user-fill-in-checklist-element-category-save-container'>
                                        <h2>
                                          {category === " " && (

                                                            <div>
                                                                Category - <span className='secondary-color-paragraph'>{category}</span>
                                                            </div>

                                                          )}
                                        </h2>

                                       
                                        
                                      </div>
                                      
                                      {questionCategoryErrors[category] && (
                                        <div className='error-text'>
                                          <ul>
                                            {questionCategoryErrors[category].map((error, index) => (
                                              <li key={index} className='category-error-item'>{error}</li>
                                            ))}
                                          </ul>
                                        </div>
                                      )}
                                      
                                      <div className='compliance-tracker-consultant-fill-in-table-main-container'>
                            <div className="compliance-tracker-consultant-fill-in-table-container">
                              <table className='compliance-tracker-consultant-fill-in-table'>

                                <colgroup>
                                  <col style={{width: "50px"}}/>
                                  <col style={{width: "300px"}}/>
                                  <col style={{width: "150px"}}/>
                                  <col style={{width: "400px"}}/>
                                  <col style={{width: "400px"}}/>
                                  <col style={{width: "300px"}}/>
                                  <col style={{width: "100px"}}/>
                                 
                                
                                </colgroup>

                              


                                <thead>
                                  <tr>
                                    <th>#</th>
                                    <th>Question</th>
                                    <th>Score</th>
                                    <th>Auditor Remark</th>
                                    <th>QA Feedback</th>
                                    <th>Consultants File Upload</th>
                                    <th>Date Updated</th>
                                    
                                  </tr>
                                </thead>
                                <tbody>
                                  {categoryQuestions.map((question, index) => (
                                    <React.Fragment key={index}>
                                      {questionErrors[question.question_id] && (
                                        <tr>
                                          <td colSpan={6} className='error-text'>
                                            <p>{questionErrors[question.question_id]}</p>
                                          </td>
                                        </tr>
                                      )}
                                      <tr className='question-table-row'>

                                        <td>
                                          <span className='secondary-color-paragraph'>{index + 1}</span>
                                        </td>

                                        

                                        <td
                                          style={{
                                            maxWidth: "300px",
                                            wordWrap: "break-word",
                                             whiteSpace: "normal"
                                          }}
                                          >
                                       
                                          <p>{question.question_name}</p>
                                          <p className='confidential' style={{ fontSize: '10px' }}>{question.question_id}</p>
                                          <p className='confidential' style={{ fontSize: '10px' }}>{question.checklist_id}</p>
                                          <div className='classNamechecklist-question-toaster-user-fill-in-checklist-question-element-options-container'>
                                            {renderQuestionOptions(question)}
                                          </div>
                                        </td>

                                        
                                        <td>
                                          <div className='she-pack-fill-in-question-score-container'>
                                            <select
                                              value={question.user_question_score ||questionScores[question.question_id] || 'Not Selected'}
                                              onChange={(e) => handleScoreChange(question.question_id, e.target.value)}
                                              className={questionErrors[question.question_id] ? 'error-border' : ''}
                                            >
                                              {generateScoreOptions(parseInt(question.question_score))}
                                            </select>
                                            <span>/{question.question_score}</span>
                                          </div>
                                        </td>

                                        <td>
                                          {question.comment === 'Yes' && (

                                            <div className='qa-status-comment-column-main-container'>

                                              <div>
                                                <p className='secondary-color-paragraph'><i>Auditor Remark :</i></p>
                                                <textarea
                                                  placeholder='No comments provided from the consultant'
                                                  rows={2}
                                                  cols={50}
                                                  maxLength={200}
                                                  value={comments[question.question_id] || ''}
                                                  onChange={(e) => handleCommentChange(question.question_id, e.target.value)}
                                                />
                                                <p><i>Max 1000 characters. </i></p>
                                              </div>

                                            </div>
                                            
                                          )}
                                         
                                        </td>

                                        <td>
                                          {question.qa_comment === 'Yes' && (

                                            <div className='qa-status-comment-column-main-container'>
                                              <div>
                                                <TbMessage2Cancel
                                                  className={`qa-view-checklist-submition-icon ${qaCommentLoading[question.question_id] ? 'loading' : ''}`}
                                                  onClick={() => handleQaCommentReject(question.question_id)}
                                                  style={{ 
                                                    opacity: qaCommentLoading[question.question_id] ? 0.5 : 1,
                                                    cursor: qaCommentLoading[question.question_id] ? 'not-allowed' : 'pointer'
                                                  }}
                                                />
                                                {qaCommentLoading[question.question_id] && (
                                                  <FaSpinner className="fa-spin" style={{ marginLeft: '10px' }} />
                                                )}
                                              </div>

                                              <div>
                                                <p className='secondary-color-paragraph'><i>QA Feed Back : </i></p>
                                                <textarea
                                                  placeholder='No comments provided by QA'
                                                  rows={2}
                                                  cols={45}
                                                  maxLength={200}
                                                  value={qaComments[question.question_id] || question.qa_comment_response}
                                                  onChange={(e) => handleQaCommentChange(question.question_id, e.target.value)}
                                                  disabled={qaCommentLoading[question.question_id]}
                                                />
                                                <p><i>Max 1000 characters. </i></p>
                                              </div>
                                            </div>
                                          )}
                                        </td>

                                        {/* */}
                                        <td
                                          style={{
                                            maxWidth: "300px",
                                            wordWrap: "break-word",
                                            whiteSpace: "normal"
                                          }}
                                        >

                                          <div>
                                            {/* Show previous file only if no new file and not removed */}
                                              {question.previous_file_response && !files[question.question_id] && !removedPreviousFiles[question.question_id] ? 
                                                renderPreviousFileResponse(question, index) : 'No file uploaded by consultant'
                                                                                                     
                                              }
                                          </div>
                                          
                                          
                                        </td>

                                        <td>{question.last_updated}</td>

                                        

                                      
                                      
                                        
                                      </tr>
                                    </React.Fragment>
                                  ))}
                                </tbody>
                              </table>
                              
                            </div>
                          </div>
                                    </div>

                                    
                                  </div>
                                ))}
                                <div>
                                      {errorMessage && (
                                        <div className='error-text'>
                                          <p>{errorMessage}</p>
                                        </div>
                                      )}
                                      <p>By clicking 'Submit Approved Template,' you confirm that you have reviewed and approved the template after completing the QA process.</p>
                                      
                                      <div className='checklist-question-toaster-button-cancel-container'>
                                        <button 
                                          onClick={() => handleSubmit(document.shepack_document_id)}
                                          className="confirm-button" disabled={submitStatus === 'loading'}>
                                          {submitStatus === 'loading' ? (
                                            <>
                                              <FaSpinner className="fa-spin" />
                                              <span className="submitting-questions-text"> Submitting questions...</span>
                                            </>
                                          ) : (
                                            'Approve Template'
                                          )}
                                        </button>

                                        <button 
                                        onClick={() => {
                                          setCurrentDocumentId(document.shepack_document_id);
                                          setShowQARejectToaster(true);
                                        }}
                                        className="reject-button" 
                                        disabled={submitStatus === 'loading'}
                                      >Reject</button>

                                      
                                      </div>
                                    </div>
                            </div>

                              </td>
                            </tr>
                            
                          )}
                 
                        
                        </>
                      ))
                    )}
                 

                    </tbody>

                  </table>
                  
                
                    
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
      {showToaster.questionSaved && <ItemAddedToaster item={'Question Saved'} />}
      {showToaster.categorySaved && <ItemAddedToaster item={'Category Saved'} />}

      {showToaster.fileSaved && <ItemAddedToaster item={'QA - Rejected With Comment'} />}

      {showSuccess && 
        
        <CreatedSuccesFullyToaster
          heading='Template Qauality Assure Review Successfull'
        />

      }

      {showQARejectToaster && (
        <QARejectToaster
          onClose={() => setShowQARejectToaster(false)}
          onSubmit={handleReject}
          documentId={currentDocumentId}
        />
      )}
        
    </div>
  );
};

export default ToasterQaViewSubmissions;